import styled from 'styled-components'
export default styled.main`
	display: flex;
`